import { checkoutShouldShowBookingProtection } from 'checkout/selectors/checkoutSectionsSelectors'
import { isInsuranceSupported } from 'checkout/selectors/request/insurance'
import createSelector from 'lib/web/createSelector'
import { isEnabledLuxPlusDiscountedInsurance } from 'luxPlus/selectors/featureToggle'

export const getAvailableInsuranceBenefits = createSelector(
  isEnabledLuxPlusDiscountedInsurance,
  isInsuranceSupported,
  checkoutShouldShowBookingProtection,
  (isEnabledLuxPlusDiscountedInsurance, insuranceSupported, shouldShowBookingProtection): App.Checkout.LuxPlusInsuranceBenefits => ({
    insuranceAvailable: isEnabledLuxPlusDiscountedInsurance && insuranceSupported,
    bookingProtection: isEnabledLuxPlusDiscountedInsurance && shouldShowBookingProtection,
  }),
)

export const getInsuranceAvailableCopy = (insuranceAvailable: boolean, bookingProtectionAvailable: boolean) => {
  if (insuranceAvailable && bookingProtectionAvailable) {
    return 'insurance & cancellation protection'
  } else if (insuranceAvailable) {
    return 'insurance'
  } else if (bookingProtectionAvailable) {
    return 'cancellation protection'
  }
  return ''
}
